const wpkReferences = document.querySelectorAll('.wp-block-wpk-references');

if(wpkReferences.length > 0) {
    //Loop through each accordion container
    for(let i = 0; i < wpkReferences.length; i++) {

        
        //Add EventListener to the block for performance
        wpkReferences[i].addEventListener('click', function (event) {

            //Click target
            var target = event.target;

            //If we click on a header
            if( target.classList.contains('title') ) {

                this.querySelector('.wrapper .wrapper .wrapper').classList.toggle('hidden');

            } else {

                this.querySelector('.wrapper .wrapper .wrapper').classList.add('hidden');
                
            }
        });
    }
}